import React from 'react'

import { Link } from 'react-router-dom'

interface DrawerMenuItemProps {
	icon?: string,
	label: string,
	link?: string,
}

const DrawerMenuItem: React.FC<DrawerMenuItemProps & any> = (props) => {
	const { icon, label, link, className, ...otherProps } = props

	return (
		<Link to={link || '/'} className={`group flex h-12 items-center px-8 cursor-pointer no-underline ${className}`} {...otherProps}>
			<div className="font-semibold text-sm text-white group-hover:text-red-600">
				{label}
			</div>
		</Link>
	)
}

export default DrawerMenuItem
